var _excluded = ["innerProps"],
    _excluded2 = ["innerProps"],
    _excluded3 = ["subOptions"],
    _excluded4 = ["id", "value", "options", "onChange", "size", "defaultMenuIsOpen", "menuIsOpen", "emptyState", "shouldHideCaret"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { isString } from 'lodash';
import { useMemo, useState } from 'react';
import ReactSelect, { components } from 'react-select';
import { Icon } from '../../../foundations/Icon';
import { forwardRef } from '../../../utils';
import { Box } from '../Box';
import { SelectControl } from './components/SelectControl';
import { SelectInput } from './components/SelectInput';
import { SelectMenuList } from './components/SelectMenuList';
import { SelectMessage } from './components/SelectMessage/SelectMessage';
import { SelectOption } from './components/SelectOption/SelectOption';
import { SelectPlaceholder } from './components/SelectPlaceholder';
import { SelectSingleValue } from './components/SelectSingleValue';
import { SelectValueContainer } from './components/SelectValueContainer';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
export var selectComponents = {
  DropdownIndicator: _ref => {
    var {
      selectProps: {
        isReadOnly,
        isViewMode,
        menuIsOpen,
        size
      }
    } = _ref;
    return isReadOnly || isViewMode ? /*#__PURE__*/_jsx(_Fragment, {}) : /*#__PURE__*/_jsx(Icon, {
      size: size,
      type: menuIsOpen ? 'caret-up' : 'caret-down',
      color: "inherit"
    });
  },
  IndicatorSeparator: () => null,
  Control: SelectControl,
  ValueContainer: SelectValueContainer,
  SingleValue: SelectSingleValue,
  Menu: _ref2 => {
    var {
      innerProps
    } = _ref2,
        props = _objectWithoutProperties(_ref2, _excluded);

    return /*#__PURE__*/_jsx(components.Menu, _objectSpread(_objectSpread({}, props), {}, {
      innerProps: _objectSpread(_objectSpread({}, innerProps), {}, {
        'data-component': '_SelectMenu'
      }),
      children: /*#__PURE__*/_jsx(Box, {
        as: "span",
        "data-testid": "select-menu",
        children: props.children
      })
    }));
  },
  MenuList: SelectMenuList,
  Option: SelectOption,
  Placeholder: SelectPlaceholder,
  Input: SelectInput,
  SelectContainer: _ref3 => {
    var {
      innerProps
    } = _ref3,
        props = _objectWithoutProperties(_ref3, _excluded2);

    return /*#__PURE__*/_jsx(components.SelectContainer, _objectSpread(_objectSpread({}, props), {}, {
      innerProps: _objectSpread(_objectSpread({}, innerProps), {}, {
        'data-component': '_Select'
      })
    }));
  }
};
export var customStyles = shouldHideCaret => ({
  menuPortal: provided => _objectSpread(_objectSpread({}, provided), {}, {
    zIndex: 1400
  }),
  menu: provided => _objectSpread(_objectSpread({}, provided), {}, {
    boxShadow: 'none',
    zIndex: 1400
  }),
  input: provided => _objectSpread(_objectSpread({}, provided), shouldHideCaret && {
    caretColor: 'transparent'
  })
});
export var menuProps = {
  menuPlacement: 'auto',
  menuPosition: 'fixed',
  menuShouldScrollIntoView: false,
  minMenuHeight: 320
};
export var flatOptionsArrayRec = (options, newArray, nestedCount) => {
  for (var option of options) {
    var {
      subOptions
    } = option,
        rest = _objectWithoutProperties(option, _excluded3);

    newArray.push(_objectSpread(_objectSpread({}, rest), {}, {
      nestedCount
    }));

    if (subOptions) {
      newArray.concat(flatOptionsArrayRec(subOptions, newArray, nestedCount + 1));
    }
  }

  return newArray;
};
/**
 * @private Please use `Form.Select` from `@melio/penny`.
 */

export var _Select = forwardRef((_ref4, ref) => {
  var {
    id,
    value,
    options = [],
    onChange,
    size = 'large',
    defaultMenuIsOpen = false,
    menuIsOpen,
    emptyState,
    shouldHideCaret = false
  } = _ref4,
      props = _objectWithoutProperties(_ref4, _excluded4);

  var [isMenuOpen, setIsMenuOpen] = useState(defaultMenuIsOpen);
  var flatOptions = useMemo(() => flatOptionsArrayRec(options, [], 0), [options]); // The selected value must be an option from the options list, yet we want to work with the value itself.

  var selectedOption = flatOptions.find(option => option.value === value); // Match the react-select's onChange to a native "event"-like onChange.

  var handleChange = selectedOption => onChange === null || onChange === void 0 ? void 0 : onChange({
    target: {
      value: selectedOption.value
    }
  }); // This ensure that the field resets when an empty string value is passed


  var key = selectedOption ? isString(selectedOption.value) ? selectedOption.value : JSON.stringify(selectedOption.value) : 'key';
  return /*#__PURE__*/_createElement(ReactSelect // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-explicit-any
  , _objectSpread(_objectSpread({
    ref: ref,
    components: selectComponents,
    menuPortalTarget: document.body
  }, props), {}, {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    size: size,
    key: "select-component-".concat(key),
    onChange: newValue => handleChange(newValue),
    options: flatOptions,
    value: selectedOption,
    styles: customStyles(shouldHideCaret),
    inputId: id,
    defaultMenuIsOpen: defaultMenuIsOpen && !props.isReadOnly && !props.isViewMode,
    menuIsOpen: isMenuOpen,
    onMenuOpen: () => setIsMenuOpen(true),
    onMenuClose: () => setIsMenuOpen(false),
    noOptionsMessage: () => /*#__PURE__*/_jsx(SelectMessage, _objectSpread(_objectSpread({}, emptyState), {}, {
      label: (emptyState === null || emptyState === void 0 ? void 0 : emptyState.label) || 'No options'
    }))
  }, menuProps));
});
_Select.displayName = '_Select';
//# sourceMappingURL=_Select.js.map